import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { HERO } from '../mock';

export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center pt-28 pb-16 overflow-hidden grid-bg">
      {/* animated blobs */}
      <div className="blob bg-[#0ef3fe] w-[420px] h-[420px] -top-20 -left-20 animate-pulse-glow" />
      <div className="blob bg-[#088ffe] w-[380px] h-[380px] top-40 right-0 animate-pulse-glow" />
      <div className="blob bg-[#0a6bd6] w-[300px] h-[300px] bottom-0 left-1/3 opacity-40" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full neon-border px-4 py-1.5 mb-6">
            <Sparkles className="h-4 w-4 text-[#0ef3fe]" />
            <span className="font-mono-accent text-xs text-white/80">{HERO.kicker}</span>
          </div>

          <h1 className="font-display text-5xl md:text-7xl font-bold leading-[1.05] mb-6">
            Innovating <span className="gradient-text animate-gradient">Tomorrow</span>, Today
          </h1>

          <p className="text-lg text-white/65 max-w-xl mb-8 leading-relaxed">
            {HERO.subtitle}
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              href="#divisions"
              className="group inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-[#0ef3fe] to-[#0a6bd6] text-black px-7 py-3.5 font-semibold hover:shadow-[0_0_30px_rgba(14,243,254,0.5)] transition-shadow"
            >
              Explore Divisions
              <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </a>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 rounded-xl neon-border px-7 py-3.5 font-semibold text-white hover:bg-white/5 transition-colors"
            >
              Get in Touch
            </a>
          </div>

          <div className="grid grid-cols-4 gap-4 mt-12 max-w-lg">
            {HERO.stats.map((s) => (
              <div key={s.label} className="text-center md:text-left">
                <div className="font-display text-2xl md:text-3xl font-bold text-glow-cyan">{s.value}</div>
                <div className="text-xs text-white/50 mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative animate-floaty">
          <div className="absolute -inset-4 bg-gradient-to-tr from-[#0ef3fe]/30 to-[#088ffe]/30 blur-2xl rounded-3xl" />
          <div className="relative rounded-3xl overflow-hidden neon-border">
            <img src={HERO.bg} alt="Neon technology" className="w-full h-[440px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a1526] via-transparent to-transparent" />
            <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between">
              <span className="font-mono-accent text-xs text-white">// SYSTEMS ONLINE</span>
              <span className="flex items-center gap-2 text-xs text-white/70">
                <span className="h-2 w-2 rounded-full bg-[#5bd0ff] animate-pulse-glow" /> Live
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
